<script setup>
  import { ref, computed } from "vue";
  import { Chart as ChartJS, registerables } from "chart.js";
  import { BarChart, LineChart } from "vue-chart-3";

  // Register all chart.js components
  ChartJS.register(...registerables);

  const props = defineProps({
    data: {
      type: Object,
      default: null,
    },
    isManager: {
      type: Boolean,
      default: "",
    },
  });

  const reportInfo = {
    cpu: props.data["vcpus"] || props.data["cpu"],
    memory: props.data["memory.resident"] || props.data["memory"],
    networkIncomingByte: props.data["network.incoming.bytes"],
    networkOutgoingByte: props.data["network.outgoing.bytes"],
  };

  // Prepare chart data for CPU
  const cpuChartData = computed(() => {
    if (!reportInfo.cpu) return null;

    const labels = reportInfo.cpu.map((item) =>
      new Date(item[0]).toLocaleTimeString()
    );
    const datasets = [
      {
        label: "CPU Usage",
        data: reportInfo.cpu.map((item) => item[2]),
        borderColor: "#02a3a8",
        backgroundColor: "#23ddf4",
        borderWidth: 2,
      },
    ];

    return {
      labels,
      datasets,
    };
  });

  // Prepare chart data for Memory
  const memoryChartData = computed(() => {
    if (!reportInfo.memory) return null;

    const labels = reportInfo.memory.map((item) =>
      new Date(item[0]).toLocaleTimeString()
    );
    const datasets = [
      {
        label: "Memory Usage",
        data: reportInfo.memory.map((item) => item[2]),
        borderColor: "#0a4ee6",
        backgroundColor: "#93a4ed",
        borderWidth: 2,
      },
    ];

    return {
      labels,
      datasets,
    };
  });

  // Prepare chart data for Memory
  const networkIChartData = computed(() => {
    if (!reportInfo.networkIncomingByte) return null;

    const labels = reportInfo.networkIncomingByte.map((item) =>
      new Date(item[0]).toLocaleTimeString()
    );
    const datasets = [
      {
        label: "network Incoming",
        data: reportInfo.networkIncomingByte.map((item) => item[2]),
        borderColor: "#30ff00",
        backgroundColor: "#bafbaa",
        borderWidth: 2,
      },
    ];

    return {
      labels,
      datasets,
    };
  });

  // Prepare chart data for Memory
  const networkOutgoingByte = computed(() => {
    if (!reportInfo.networkOutgoingByte) return null;

    const labels = reportInfo.networkOutgoingByte.map((item) =>
      new Date(item[0]).toLocaleTimeString()
    );
    const datasets = [
      {
        label: "network Outgoing",
        data: reportInfo.networkOutgoingByte.map((item) => item[2]),
        borderColor: "#efe100",
        backgroundColor: "#f6f4c9",
        borderWidth: 2,
      },
    ];

    return {
      labels,
      datasets,
    };
  });

  // Chart options
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Dynamic Report Chart",
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10,
        },
        title: {
          display: true,
          text: "Time",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Value",
        },
      },
    },
  };
</script>

<template>
  <section class="mt-4">
    <div class="grid grid-cols-2 gap-4">
      <div class="p-10">
        <BarChart
          v-if="cpuChartData"
          :chart-data="cpuChartData"
          :chart-options="chartOptions"
        />
      </div>
      <div class="p-10">
        <!--      <BarChart v-if="memoryChartData" :chart-data="memoryChartData" :chart-options="chartOptions"/>-->
        <LineChart
          v-if="memoryChartData"
          :chart-data="memoryChartData"
          :chart-options="chartOptions"
        />
      </div>
      <div class="p-10">
        <BarChart
          v-if="networkIChartData"
          :chart-data="networkIChartData"
          :chart-options="chartOptions"
        />
      </div>
      <div class="p-10">
        <BarChart
          v-if="networkOutgoingByte"
          :chart-data="networkOutgoingByte"
          :chart-options="chartOptions"
        />
      </div>
    </div>
  </section>
</template>
